<template>
  <div class="login-container">
    <div class="login-box">
      <div class="header">新希望地产管理后台</div>
      <el-form ref="loginRef" :model="login" :rules="rules" :hide-required-asterisk="true">
        <el-form-item class="account" prop="account">
          <el-input
            clearable
            placeholder="账号"
            v-model="login.account"
            prefix-icon="el-icon-user"
          ></el-input>
        </el-form-item>
        <el-form-item class="password" prop="password">
          <el-input
            type="password"
            clearable
            placeholder="密码"
            v-model="login.password"
            prefix-icon="el-icon-lock"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit" round class="submit-button"
            >登 录</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoginPage",
  data() {
    return {
      login: {
        account: "",
        password: "",
      },
      rules: {
        account: [
          {
            required: true,
            message: "请输入账号",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submit() {
      // 校验
      this.$refs.loginRef.validate((valid) => {
        if (!valid) return;

        console.log(this.login, 'login-----------')
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.login-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background: url("../../assets/images/admin/bg.jpg");

  .login-box {
    width: 480px;
    box-sizing: border-box;
    min-height: 380px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.51);
    padding: 42px 40px 32px;
  }

  .header {
    height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: #333;
    line-height: 33px;
    margin-bottom: 40px;
  }

  .submit-button {
    width: 100%;
    margin-top: 30px;
  }
}
</style>
